export default __webpack_public_path__ + "static/media/mapel.ad457e26.png";